<template>
    <div class="my-container">
        <!-- Card Principal Integrado -->
        <div class="my-card">
            <!-- Header do DataTable -->
            <div class="my-header">
                <div class="header-left">
                    <h1 class="datatable-title">Ficha de Dados de Segurança</h1>
                    <span class="records-summary">{{ products.length }} produto(s)</span>
                </div>
                <div class="header-right">
                    <!-- Espaço para botões futuros se necessário -->
                </div>
            </div>

            <!-- Área de Conteúdo Unificada -->
            <div class="datatable-main-content">
                <!-- Loading State -->
                <div class="datatable-loading" v-if="spinner">
                    <div class="loading-overlay">
                        <div class="loading-spinner">
                            <div class="spinner"></div>
                        </div>
                        <div class="loading-text">
                            <h4>Carregando produtos...</h4>
                            <p>Aguarde enquanto buscamos os dados</p>
                        </div>
                    </div>
                </div>

                <!-- Tabela Principal -->
                <div class="datatable-content" v-else>
                    <!-- Alert informativo -->
                    <div class="info-alert">
                        <i class="fa fa-info-circle"></i>
                        <span>Produtos com o botão inativo não possuem FDS disponível, favor entre em contato com o atendimento</span>
                    </div>

                    <!-- Wrapper da Tabela -->
                    <div class="table-responsive">
                        <table class="datatable">
                            <thead class="my-header-row">
                                <tr>
                                    <th class="datatable-th">Produto</th>
                                    <th class="datatable-th">Visualizar</th>
                                </tr>
                            </thead>
                            <tbody v-if="products.length > 0">
                                <tr v-for="product in products" :key="product.id" class="datatable-row">
                                    <td class="datatable-td">
                                        <div class="field-value">{{ product.name }}</div>
                                    </td>
                                    <td class="datatable-td">
                                        <button
                                            @click="fispq(product)"
                                            class="btn btn-primary btn-action"
                                            :disabled="!product.fispq"
                                            :title="product.fispq ? 'Visualizar FDS' : 'FDS não disponível'"
                                        >
                                            <i class="fa fa-search"></i>
                                            <span class="btn-text">Visualizar</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="2" class="text-center">
                                        <div class="empty-state">
                                            <div class="empty-content">
                                                <i class="fa fa-inbox empty-icon"></i>
                                                <h4>Nenhum documento disponível</h4>
                                                <p>Não há produtos com FDS no momento</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Footer com informações -->
            <div class="datatable-footer">
                <div class="footer-left">
                    <div class="footer-info">
                        <span>Total de produtos: {{ products.length }}</span>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="footer-actions">
                        <!-- Espaço para ações futuras -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {createToaster} from "@meforma/vue-toaster";

const toaster = createToaster({
    position: "top-right",
});
export default {
    data() {
        return {
            products: [],
            spinner: true
        };
    },
    computed: {},
    components: {},
    methods: {
        fispq(product) {
            console.log(product);
            product = btoa(
                JSON.stringify({
                    code: product.code,
                    document_id: 1,
                    name: encodeURIComponent(product.name) 
                })
            );
            this.$router.push("/admin/document/fispq/" + product);
        },
        async getProducts() {
            const [codes, products] = await Promise.allSettled([this.getCodes(), this.getCustomerProduct()]);
            
            codes.value.forEach( (code) => {

                code.product_code.forEach( (internalCode) => {

                    products.value.forEach( (product) => {
                        if (internalCode.product_code === product.code) this.products.push(product);
                    })
                })

            })

            this.spinner = false;
        },
        async getCodes() {
            const self = this;
            const api = this.$store.state.api + "intertox_codes?paginated=false&with[]=product_code";

            try {
                const response = await axios.get(api);
                return response.data.data;
            } catch (error) {
                this.$toast.error(error.response.data.message);
                self.loading = false;
                return [];
            }
        },
        async getCustomerProduct() {
            const self = this;
            const api = this.$store.state.api + "customer-products";

            try {
                const response = await axios.get(api);
                return Object.values(response.data.data);
            } catch (error) {
                self.$toast.error(error.response.data.message);
                self.loading = false;
                return [];
            }
        }
    },
    mounted() {
        const self = this;

        self.getProducts();
    },
};
</script>

<style scoped>
/* Importando os estilos do BaseTable.vue */

/* DataTable Container */
.my-container {
    padding: 0;
    background: transparent;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

/* Card Principal */
.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    min-height: 500px;
    display: flex;
    flex-direction: column;
}

/* Header do DataTable */
.my-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: 1px solid #e9ecef;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.datatable-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: white;
}

.records-summary {
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.header-right {
    display: flex;
    gap: 8px;
}

/* Container Principal Unificado */
.datatable-main-content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    overflow-x: auto;
    max-width: 100%;
    position: relative;
}

/* Loading State */
.datatable-loading {
    padding: 60px 24px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    min-height: inherit;
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 400px;
}

.loading-spinner .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text h4 {
    font-size: 18px;
    color: #495057;
    margin: 0 0 8px 0;
}

.loading-text p {
    color: #6c757d;
    margin: 0;
}

/* Conteúdo da Tabela */
.datatable-content {
    background: white;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: inherit;
    padding: 20px 24px;
}

/* Alert informativo */
.info-alert {
    background: #d1ecf1;
    border: none;
    border-left: 4px solid #17a2b8;
    color: #0c5460;
    padding: 12px 16px;
    margin-bottom: 20px;
    border-radius: 4px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.info-alert i {
    font-size: 16px;
    color: #17a2b8;
}

/* Tabela */
.table-responsive {
    overflow-x: auto;
    max-width: 100%;
    box-sizing: border-box;
    flex: 1;
    min-height: 300px;
    display: flex;
    flex-direction: column;
}

.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    background: white;
    table-layout: auto;
}

.my-header-row {
    background: #f8f9fa;
}

.datatable-th {
    padding: 12px 16px;
    text-align: center;
    font-weight: 600;
    color: #495057;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e9ecef;
    background: #f8f9fa;
    white-space: nowrap;
}

.datatable-row {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f3f4;
}

.datatable-row:hover {
    background: #f8f9fa;
}

.datatable-td {
    padding: 16px;
    color: #495057;
    font-size: 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f3f4;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.5;
}

.field-value {
    word-break: break-word;
    line-height: 1.4;
}

/* Botões de ação */
.btn-action {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
}

.btn-primary {
    background: #667eea;
    color: white;
}

.btn-primary:hover:not(:disabled) {
    background: #5a6fd8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-primary:disabled {
    background: #adb5bd;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.btn-text {
    font-size: 13px;
}

/* Estado Vazio */
.empty-state {
    padding: 60px 20px;
    text-align: center;
    background: white;
}

.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.empty-icon {
    font-size: 48px;
    color: #adb5bd;
}

.empty-content h4 {
    font-size: 18px;
    color: #495057;
    margin: 0;
}

.empty-content p {
    color: #6c757d;
    margin: 0;
    font-size: 14px;
}

/* Footer */
.datatable-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    flex-wrap: wrap;
    gap: 16px;
    max-width: 100%;
    box-sizing: border-box;
}

.footer-left,
.footer-right {
    display: flex;
    align-items: center;
}

.footer-info {
    font-size: 13px;
    color: #495057;
    font-weight: 500;
}

/* Responsividade */
@media (max-width: 768px) {
    .my-container {
        padding: 0;
    }

    .my-header {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        padding: 16px;
    }

    .header-left {
        width: 100%;
    }

    .datatable-content {
        padding: 16px;
    }

    .datatable-footer {
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
    }

    .footer-left,
    .footer-right {
        width: 100%;
        justify-content: center;
    }

    .datatable-th,
    .datatable-td {
        padding: 12px;
        font-size: 13px;
    }

    .btn-text {
        display: none;
    }
}

@media (max-width: 576px) {
    .datatable-title {
        font-size: 20px;
    }

    .records-summary {
        font-size: 12px;
        padding: 2px 8px;
    }

    .datatable-th,
    .datatable-td {
        padding: 10px;
        font-size: 12px;
    }

    .datatable-loading {
        padding: 40px 16px;
        min-height: 300px;
    }

    .datatable-content {
        min-height: 300px;
        padding: 12px;
    }

    .my-card {
        min-height: 400px;
    }

    .btn-action {
        padding: 6px 10px;
        font-size: 12px;
    }
}
</style>